import datetime from "@/mixins/datetime"
export default{
    mixins:[datetime], 
    methods:{
        getRecentUnitPrice(estimate, end){
            let [end1, end2, end3] = this.enddateAsc(estimate.end_date_of_application, estimate.end_date_of_application_2, estimate.end_date_of_application_3);
            //console.log(end1, end2, end3);
            if(end1 != null && end1.add(1,'days').format('YYYY-MM-DD') > end){
                return this.getEqualUnit(end1, estimate)
            }else if(end2 != null && end2.add(1,'days').format('YYYY-MM-DD') > end){
                return this.getEqualUnit(end2, estimate)
            }else if(end3 != null && end3.add(1,'days').format('YYYY-MM-DD') > end){
                return this.getEqualUnit(end3, estimate)
            }else{
                return '';
            }
        },
        getEqualUnit(end , estimate){
            end = end.subtract(1,"days").format('YYYY-MM-DD');
            if(end == estimate.end_date_of_application){
                return estimate.unit_price;
            }else if(end == estimate.end_date_of_application_2){
                return estimate.unit_price_2;
            }else if(end == estimate.end_date_of_application_3){
                return estimate.unit_price_3;
            }else {
                return '';
            }
        }
    }
}